import { POST_BUSINESS_PROFILE } from "../configs/routes.js";
import api from "./api.js";

const putBusinessProfile = (businessData = {}) =>
  new Promise((resolve, reject) => {
    api
      .post(POST_BUSINESS_PROFILE, businessData)
      .then((response) => resolve(response.data))
      .catch((err) => reject(err.message));
  });

export default putBusinessProfile;
